@if (energyType == EnergyType.ELECTRICITY)
{
{{ 'shared.electricity' | transloco }}
} @else if (energyType == EnergyType.GAS)
{
{{ 'shared.gas' | transloco }}
}